import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHistory = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 16,
	viewBox: "0 0 18 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M0 4.5V11.5C0 12.3438 0.65625 13 1.5 13V3C0.65625 3 0 3.6875 0 4.5ZM3 3V13C3 13.8438 3.65625 14.5 4.5 14.5V1.5C3.65625 1.5 3 2.1875 3 3ZM16 0H8C6.875 0 6 0.90625 6 2V14C6 15.125 6.875 16 8 16H16C17.0938 16 18 15.125 18 14V2C18 0.90625 17.0938 0 16 0ZM16.5 14C16.5 14.2812 16.25 14.5 16 14.5H8C7.71875 14.5 7.5 14.2812 7.5 14V2C7.5 1.75 7.71875 1.5 8 1.5H16C16.25 1.5 16.5 1.75 16.5 2V14Z",
		fill: "#607D8B"
	})]
});
const ForwardRef = forwardRef(SvgHistory);
export { ForwardRef as ReactComponent };
